import { render, staticRenderFns } from "./socialservice.vue?vue&type=template&id=0f0f4e09&scoped=true&"
import script from "./socialservice.vue?vue&type=script&lang=js&"
export * from "./socialservice.vue?vue&type=script&lang=js&"
import style0 from "./socialservice.vue?vue&type=style&index=0&id=0f0f4e09&scoped=true&lang=less&"
import style1 from "./socialservice.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0f4e09",
  null
  
)

export default component.exports